import { useTranslation } from "react-i18next";
import { statusPalette, type Tone } from "../theme";

const TONES: Record<string, Tone> = {
  // runs / tasks
  running: "info",
  awaiting_approval: "warning",
  awaiting_input: "warning",
  finished: "success",
  completed: "success",
  error: "error",
  failed: "error",
  cancelled: "neutral",
  open: "info",
  claimed: "info",
  pending: "warning",
  approved: "success",
  edited: "success",
  rejected: "error",
  expired: "neutral",
  resolved: "success",
  closed: "neutral",
  ok: "success",
  // registry / evals
  production: "success",
  staging: "info",
  draft: "neutral",
  suspended: "error",
  retired: "neutral",
  not_evaluated: "neutral",
  // ops
  firing: "error",
  acknowledged: "warning",
  healthy: "success",
  progressing: "info",
  paused: "warning",
  degraded: "error",
  aborted: "error",
  passing: "success",
  failing: "error",
  mitigated: "warning",
  engaged: "error",
  disengaged: "success",
  allowed: "success",
  excepted: "warning",
  denied: "error",
  unknown: "error",
  critical: "error",
  warning: "warning",
  info: "info",
  ready: "success",
  processing: "info",
  done: "success",
  escalated: "error",
  scale_up: "warning",
  scale_down: "info",
  hold: "neutral",
};

/** Status label (translated via `common:status.<status>`) with an accessible colour pair. */
export function StatusTag({ status, tone, label }: { status: string; tone?: Tone; label?: string }) {
  const { t } = useTranslation("common");
  const p = statusPalette[tone ?? TONES[status] ?? "neutral"];
  return (
    <span
      data-status={status}
      style={{
        display: "inline-block",
        paddingInline: 8,
        paddingBlock: 1,
        borderRadius: 4,
        fontSize: 12,
        lineHeight: "20px",
        whiteSpace: "nowrap",
        color: p.color,
        background: p.background,
        border: `1px solid ${p.border}`,
      }}
    >
      {label ?? t(`status.${status}`, { defaultValue: status })}
    </span>
  );
}
